export default __webpack_public_path__ + "static/media/default.d427f841053d688c756993a9e82de548.png";